import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    background: 'white',
    boxShadow: theme.shadows[1],
    flex: 1,
  },
  form: {
    padding: theme.spacing(2),
    width: '100%',
  },
  formSubmiting: {
    padding: theme.spacing(2),
    opacity: '0.3',
  },
  titleContent: {
    //position: 'sticky',
    //top: 0,
    backgroundColor: '#ffff',
    //zIndex: 100,
    borderBottom: '1px solid #eadada99',
  },
  title: {
    color: '#192542',
    padding: theme.spacing(2),
    textTransform: 'uppercase',
    fontSize: '1.1rem',
    fontWeight: 500,
  },
  anchorContent: {
    position: 'sticky',
    top: 0,
    paddingTop: theme.spacing(2),
  },
  tAnchor: {
    marginBottom: theme.spacing(2),
  },
  anchor: {
    fontSize: '1.1rem',
    color: '#192542',
    fontWeight: 500,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
  },
  buttonProgressWrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  loadingLinear: {
    width: '100%',
  },
  action: {
    marginRight: 16,
  },
}));

export default useStyle;
